import { gql } from '@apollo/client'

export const GET_BOOKING_SCHEDULER_CONTROLS = gql`
  query GetBookingSchedulerControls($id: Long!) {
    bookingSchedulerControls(bookingId: $id) {
      edges {
        node {
          id
          schedulerType
          isAvailableGlobally
          context
          isEnabledForBooking
          isInitialized
          nextAttemptAt
          lastAttemptAt
          lastOutcome
          currentStatus
          lastOutcomeReason
          retryCount
        }
      }
    }
  }
`
